import React from 'react';

import { Map, MouseTool, Circle, Polygon, Markers, Marker} from 'react-amap';

import Cache from '../frame/Cache';
import Widget from '../widget/Widget';
import Config from '../config/Config';
import WidgetAjax from "../widget/WidgetAjax";
import WidgetSelect from '../widget/WidgetSelect';


import '../css/map.css';

class MapPOI extends React.Component
{
    constructor( props )
    {
        super(props);

        const self = this;

        let userInfo = sessionStorage.getItem("_user_info_");

        if( userInfo!==undefined && userInfo!==null )
        {
            userInfo = JSON.parse(userInfo);
        }

        this.state = {
            userInfo:userInfo,
            basePath:Config.getBasePath(),
            amap:{
                mapPlugins:['ToolBar'],
                mapZoom: 13, //地图缩放等级 （zoom）
                mapKey: 'f8061d856445cfb7db9937cd5c98aa05',//Key就不贴出来了奥
                status: {
                    zoomEnable: true,
                    dragEnable: true,
                },
                mapCenter:[116.292329, 39.946996], //地图中心点
            },
            overlays:[],
            mapLabelType:undefined,
            circle : {},
            polygon : {
                path:[
                    {longitude:1, latitude:1},
                    {longitude:1, latitude:2},
                    {longitude:2, latitude:2},
                    {longitude:2, latitude:1}
                ],
                style:{
                    strokeColor: '#4AA7F9',
                    strokeWeight : 2,
                    fillColor:"#4AA7F9",
                    fillOpacity:0.4
                },
                visible : false
            },
            mapMarkers :[],
            filterTypeOptions : {
                title : "所在地归属银行",
                cleanable:false,
                searchable:true
            },
            circleRadiusOptions : {
                title : "周边范围",
                cleanable:false
            },
            filterBankData : [],             
            circleRadiusData : [
                {label:"请选择周边范围", value:0},
                {label:"1KM", value:1000},
                {label:"2KM", value:2000},
                {label:"3KM", value:3000},
                {label:"5KM", value:5000},
                {label:"7KM", value:7000},
                {label:"10KM", value:10000},
                {label:"15KM", value:15000},
            ],  
            circleCenter : undefined,
            circleRadius : undefined,
            mapConditions : {}
        };

        this.toolEvents = {
            created: ( tool ) => {
                self.tool = tool;
            },

            draw({obj}) {
                self.drawMap(obj);
            }
        }

        this.mapPlugins = ['ToolBar'];

        this.clear = this.clear.bind(this);
        this.drawMap = this.drawMap.bind(this);
        this.drawCircle = this.drawCircle.bind(this);
        this.drawPolygon = this.drawPolygon.bind(this);
        this.drawRectangle = this.drawRectangle.bind(this);
        
        this.loadBankData = this.loadBankData.bind(this)
        this.onloadBankData = this.onloadBankData.bind(this)

        this.onSelectCircleCenter = this.onSelectCircleCenter.bind(this);
        this.onSelectCircleRadius = this.onSelectCircleRadius.bind(this);

        this.init = this.init.bind(this);
    }

    componentDidMount()
    {
        if( this.props.mapConditions!==undefined )
        {
            this.init(this.props.mapConditions);
        }
        this.loadBankData()
    }

    componentWillReceiveProps( nextProps )
    {
        let {mapConditions } = this.state;

        if( nextProps.mapConditions!==mapConditions )
        {
            if( nextProps.mapConditions!==undefined )
            {
                this.init(nextProps.mapConditions);
            }
        }
    }

    init( mapConditions )
    {
        switch( mapConditions.mapType )
        {
            case "range":
            {
                let { amap } = this.state, mapMarkers = [];

                let circleCenter = mapConditions.circleCenter;
                let circleRadius =  mapConditions.circleRadius;

                if( circleCenter!==undefined && circleRadius!==undefined )
                {
                    let position = {
                        longitude:circleCenter.coordinate[0],
                        latitude:circleCenter.coordinate[1]
                    };

                    amap["mapCenter"] = circleCenter.coordinate;

                    mapMarkers.push({position:position});


                    if( this.tool )
                    {
                        this.tool.close(true);
                        this.tool.circle();
                    }

                    let circle = {
                        center : circleCenter.coordinate,
                        radius : circleRadius.value,
                        visible: true,
                        style: {
                            strokeColor: '#4AA7F9',
                            strokeWeight : 2,
                            fillColor:"#4AA7F9",
                            fillOpacity:0.4
                        },
                    }

                    if( circleRadius.value>=7000 )
                    {
                        amap["mapZoom"] = 11;
                    }

                    this.setState({circleCenter:circleCenter, circleRadius:circleRadius, circle:circle, mapMarkers:mapMarkers, amap:amap, mapConditions:mapConditions});
                }

                break;

            }
            case "circle" : 
            {
                
                let center =  mapConditions.center;
                let radius =  mapConditions.radius;

                let circle = {
                    center : center,
                    radius : radius,
                    visible: true,
                    style: {
                        strokeColor: '#4AA7F9',
                        strokeWeight : 2,
                        fillColor:"#4AA7F9",
                        fillOpacity:0.4
                    },
                }

                if( this.tool )
                {
                this.tool.circle();
                }

                this.setState({circle:circle, circleCenter:undefined, circleRadius:undefined, markers:[], mapConditions:mapConditions});

                break;
            }
            case "rectangle":
            {
                let rectanglePath = [];

                for(let point of mapConditions["points"] )
                {
                    rectanglePath.push({longitude:point[0], latitude:point[1]});
                }

                let polygon = {
                    path : rectanglePath,
                    visible: true,
                    style: {
                        strokeColor: '#4AA7F9',
                        strokeWeight : 2,
                        fillColor:"#4AA7F9",
                        fillOpacity:0.4
                    },
                }
                if( this.tool )
                {
                    this.tool.rectangle();
                }
                this.setState({polygon:polygon, circleCenter:undefined, circleRadius:undefined,  markers:[], mapConditions:mapConditions});

                break;
            }
            case "polygon":
            {

                let polygonPath = [];

                for(let point of mapConditions["points"])
                {
                    polygonPath.push({ latitude:point[1], longitude:point[0]});
                }

                let polygon = {
                    path : polygonPath,
                    visible: true,
                    style: {
                        strokeColor: '#4AA7F9',
                        strokeWeight : 2,
                        fillColor:"#4AA7F9",
                        fillOpacity:0.4
                    },
                }
                if( this.tool )
                {
                    this.tool.polygon();
                }
                this.setState({polygon:polygon, circleCenter:undefined, circleRadius:undefined, markers:[], mapConditions:mapConditions});

                break;
            }
        }
    }

    loadBankData()
    {
        let { basePath, userInfo } = this.state, params = {};

        if( userInfo!==undefined && userInfo!==null && userInfo.realmId!==undefined )
        {
            params = {
                "TYPE":userInfo.realmId
            }
        }
    
        WidgetAjax.ajax({url:basePath + '/poi/info', params:params, callback:this.onloadBankData});
    }

    onloadBankData(result)
    {
        if( result.status===0 ) 
        {
            let newBankData = []
            result.results.forEach((val,index)=>{
                newBankData.push({
                    label:val.NAME,
                    value:index,
                    coordinate:[val.LOCATION.Lon,val.LOCATION.Lat]
                })
            })
            this.setState({
                filterBankData:newBankData
            })
        }
        else if( result.status===10 )
        {
            Cache.logout(this.props);
        }
    }  

    drawMap( obj )
    {
        this.tool.close(true);

        let { mapLabelType, mapConditions } = this.state;

        mapConditions["circleCenter"] = undefined; 
        mapConditions["circleRadius"] = undefined;

        switch( mapLabelType )
        {
            case "circle" : 
            {
                let center =  obj.getCenter();
                let radius =  obj.getRadius();

                let circle = {
                    center : [center.lng, center.lat],
                    radius : radius,
                    visible: true,
                    style: {
                        strokeColor: '#4AA7F9',
                        strokeWeight : 2,
                        fillColor:"#4AA7F9",
                        fillOpacity:0.4
                    },
                }

                this.tool.circle();

                mapConditions["mapType"] = "circle";
                mapConditions["center"] = [center.lng, center.lat];
                mapConditions["radius"] = radius;
                
                this.setState({circle:circle, circleCenter:undefined, circleRadius:undefined, markers:[], mapConditions:mapConditions});

                this.notify(mapConditions);

                break;
            }
            case "rectangle":
            {
                let path = obj.getPath(), rectanglePath = [], leftTop, rightBbuttom;

                mapConditions["mapType"] = "rectangle";

                mapConditions["points"] = [];

                for( let i=0; i<path.length; i++ )
                {
                    let item = path[i];

                    rectanglePath.push({longitude:item.lng, latitude:item.lat});

                    mapConditions["points"].push([item.lng, item.lat]);
                }

                let polygon = {
                    path : rectanglePath,
                    visible: true,
                    style: {
                        strokeColor: '#4AA7F9',
                        strokeWeight : 2,
                        fillColor:"#4AA7F9",
                        fillOpacity:0.4
                    },
                }

                this.tool.rectangle();

                this.setState({polygon:polygon, circleCenter:undefined, circleRadius:undefined,  markers:[], mapConditions:mapConditions});

                this.notify(mapConditions);
                break;
            }
            case "polygon":
            {
                let path =  obj.getPath();

                let polygonPath = [];

                mapConditions["mapType"] = "polygon";

                mapConditions["points"] = [];

                for( let item of path )
                {
                    polygonPath.push({ latitude:item.lat, longitude:item.lng});

                    mapConditions["points"].push([item.lng, item.lat]);
                }

                let polygon = {
                    path : polygonPath,
                    visible: true,
                    style: {
                        strokeColor: '#4AA7F9',
                        strokeWeight : 2,
                        fillColor:"#4AA7F9",
                        fillOpacity:0.4
                    },
                }

                this.tool.polygon();

                this.setState({polygon:polygon, circleCenter:undefined, circleRadius:undefined,  markers:[], mapConditions:mapConditions});

                if( this.props.notify!==undefined && this.props.notify!==null )
                {
                    this.props.notify(mapConditions);
                }

                break;
            }
        }
    }

    notify( mapConditons )
    {
        if( this.props.notify!==undefined &&  this.props.notify!==null )
        {
            this.props.notify(mapConditons);
        }
    }
 
    /**
     * 画圆
     */
    drawCircle()
    {
        let {circle, polygon} = this.state;

        if( this.tool )
        {
            this.tool.close(true);
            this.tool.circle();
        }

        circle["visible"] = false;
        polygon["visible"] = false;

        this.setState({mapLabelType:"circle", circle:circle, polygon:polygon});
    }

    /**
     * 画矩形
     */
    drawRectangle()
    {
        let {circle, polygon } = this.state;

        if( this.tool )
        {
            this.tool.close(true);
            this.tool.rectangle();
        }

        circle["visible"] = false;
        polygon["visible"] = false;

        this.setState({mapLabelType:"rectangle", circle:circle, polygon:polygon});
    }

    /**
     * 画多边形
     */
    drawPolygon() 
    {
        let {circle, polygon } = this.state;

        if (this.tool) 
        {
            this.tool.close(true);
            this.tool.polygon();
        }

        circle["visible"] = false;
        polygon["visible"] = false;

        this.setState({mapLabelType:"polygon", circle:circle, polygon:polygon});
    }

    /**
     * 清除
     */
    clear()
    {
        let {circle, polygon, mapConditions} = this.state;

        circle["visible"] = false;
        polygon["visible"] = false;

        this.tool.close(true);

        for( let key in mapConditions)
        {
            if( key!=="D150001" )
            {
                delete mapConditions[key];
            }
        }

        this.setState({mapLabelType:"clear", circle:circle, polygon:polygon, circleCenter:undefined, circleRadius:undefined,  markers:[], mapConditions:mapConditions});
    }

    /**
     * 选择圆形中点
     * @param {*} value 
     * @param {*} item 
     * @param {*} event 
     */
    onSelectCircleCenter(value, item, event)
    {
        let { amap, mapConditions } = this.state, mapMarkers = [];
        
        if(item === undefined)
        {
            return null;
        }
        
        if( item!==undefined && item!==null )
        {
            let position = {
                longitude:item.coordinate[0],
                latitude:item.coordinate[1]
            };
            amap["mapCenter"] = item.coordinate;
            amap["mapZoom"] = 13;
    
            mapMarkers.push({position:position});
    
            mapConditions["mapType"] = "range";
            mapConditions["circleCenter"] = item;
    
            this.setState({circleCenter:item, mapMarkers:mapMarkers, amap:amap, mapConditions:mapConditions});
    
            this.notify(mapConditions);
        }
    }

    /**
     * 选择圆形半径
     * @param {*} value 
     * @param {*} item 
     * @param {*} event 
     */
    onSelectCircleRadius(value, item, event)
    {
        let { circleCenter, amap, mapConditions } = this.state;

        if( item!==undefined && item!==null && circleCenter!==undefined && circleCenter!==null && circleCenter.coordinate!==undefined )
        {
            if( this.tool )
            {
                this.tool.close(true);
                this.tool.circle();
            }

            let circle = {
                center : circleCenter.coordinate,
                radius : item.value,
                visible: true,
                style: {
                    strokeColor: '#4AA7F9',
                    strokeWeight : 2,
                    fillColor:"#4AA7F9",
                    fillOpacity:0.4
                },
            }

            amap["mapZoom"] = 13;

            if( item.value>=7000 )
            {
                amap["mapZoom"] = 11;
            }

            mapConditions["circleRadius"] = item;

            this.setState({circleRadius:item, circle:circle, amap:amap, mapConditions:mapConditions});

            this.notify(mapConditions);
        }
        
    }
    
    render()
    {
        let { amap, mapLabelType, circle, polygon, mapMarkers,
            filterTypeOptions, filterBankData, circleCenter, circleRadius, circleRadiusOptions, circleRadiusData } = this.state;

        let circleRadiusValue, circleCenterValue;

        if( circleCenter!==undefined && circleCenter!==null )
        {
            circleCenterValue = circleCenter.value;
        }

        if( circleRadius!==undefined && circleRadius!==null )
        {
            circleRadiusValue = circleRadius.value;
        }
        
        return (
            <div style={{width: '100%', height: '100%'}}>
                <div className="map-filter">
                    <div className="filter-item">
                        <WidgetSelect onSelect={this.onSelectCircleCenter} options={filterTypeOptions} data={filterBankData} defaultValue={circleCenterValue} /> 
                        <WidgetSelect onSelect={this.onSelectCircleRadius} options={circleRadiusOptions} data={circleRadiusData} defaultValue={circleRadiusValue}/> 
                    </div>
                    <div className="map-button">
                        <label className={ mapLabelType==='rectangle' ? 'active click':'click'} onClick={() =>{this.drawRectangle()}}>
                            <div className="button-content">
                                <img src={ mapLabelType==='rectangle' ? require('../img/frame/map/rectangle-select.svg') : require('../img/frame/map/rectangle.svg')} />矩形</div>
                        </label>
                        <label className={ mapLabelType==='circle' ? 'active click':'click'} onClick={() =>{this.drawCircle()}}>
                            <div className="button-content"><img src={mapLabelType==='circle' ? require('../img/frame/map/circle-select.svg') : require('../img/frame/map/circle.svg')}/> 圆形</div>
                        </label>
                        <label className={ mapLabelType==='polygon' ? 'active click':'click'} onClick={() =>{this.drawPolygon()}}>
                            <div className="button-content"><img src={mapLabelType==='polygon' ? require('../img/frame/map/polygon-select.svg') : require('../img/frame/map/polygon.svg')}/> 多边形</div>
                        </label>
                        <label className={ mapLabelType==='clear' ? 'active click':'click'} onClick={() =>{this.clear()}}>
                            <div className="button-content"><img src={mapLabelType==='clear' ? require('../img/frame/map/clear-select.svg') : require('../img/frame/map/clear.svg')}/> 清除</div>
                        </label>
                    </div>
                </div>
                <div style={{width: '100%', height: '100%'}}>
                    <Map amapkey={amap.mapKey} center={amap.mapCenter} zoom={amap.mapZoom} status={amap.status} plugins={amap.mapPlugins}>
                        <Markers markers={mapMarkers} /> 
                        <MouseTool events={this.toolEvents}/>
                        <Circle center={circle.center} radius={ circle.radius } style={circle.style} visible={circle.visible!==undefined ? circle.visible : true}/>
                        <Polygon path={polygon.path} style={polygon.style} visible={polygon.visible!==undefined ? polygon.visible : true} />
                    </Map>
                </div>
            </div>
        );
    }
}

export default MapPOI